import React, { useRef, useState } from "react";
import { Play, Square } from "lucide-react";
import { strum } from "@/components/games/GuitarParts";

const COUNTS = ["1", "&", "2", "&", "3", "&", "4", "&"];
const G = [3, 2, 0, 0, 0, 3];
const SLOT_MS = 330;

// Strumming patterns: D = down strum, U = up strum, "-" = miss that half-beat (keep the hand moving).
export const StrumPatterns = ({ patterns, testId = "strum-patterns" }) => {
  const [playing, setPlaying] = useState(null);
  const ids = useRef([]);
  const stop = () => { ids.current.forEach(clearTimeout); ids.current = []; setPlaying(null); };
  const play = (k) => {
    stop(); setPlaying(k);
    const p = patterns[k].slots;
    [0, 1].forEach((bar) => p.forEach((sl, j) => {
      if (sl !== "-") ids.current.push(setTimeout(() => strum(G, sl === "U"), (bar * 8 + j) * SLOT_MS));
    }));
    ids.current.push(setTimeout(() => setPlaying(null), 16 * SLOT_MS));
  };
  return (
    <div className="mt-5 grid gap-3" data-testid={testId}>
      {patterns.map((pt, k) => (
        <div key={pt.name} className="rounded-2xl border border-border bg-card p-4" data-testid={`${testId}-${k}`}>
          <div className="flex items-center justify-between gap-2">
            <p className="font-medium">{pt.name}</p>
            <button type="button" onClick={() => (playing === k ? stop() : play(k))} data-testid={`${testId}-play-${k}`}
              className="flex items-center gap-1.5 rounded-full bg-primary/10 px-3 py-1 text-xs font-medium text-primary hover:bg-primary/20">
              {playing === k ? <><Square size={12} /> Stop</> : <><Play size={13} /> Hear it on G</>}
            </button>
          </div>
          <div className="mt-3 grid grid-cols-8 gap-1 text-center font-mono">
            {pt.slots.map((sl, j) => <span key={`a${j}`} className={`text-2xl ${sl === "-" ? "text-muted-foreground/30" : "text-primary"}`}>{sl === "D" ? "↓" : sl === "U" ? "↑" : "·"}</span>)}
            {COUNTS.map((c, j) => <span key={`c${j}`} className="text-xs text-muted-foreground">{c}</span>)}
          </div>
        </div>
      ))}
      <p className="text-center text-xs text-muted-foreground">↓ = strum down (towards the floor) · ↑ = strum up · · = keep your hand moving but miss the strings</p>
    </div>
  );
};
